import React, { useState } from "react";
import { Link } from "react-router-dom";
import { addDoc, collection, doc, increment, serverTimestamp, updateDoc } from "firebase/firestore";
import SEO from "../../config/SEO";
import toasted from "../../config/toasted";
import { categoriesItes, promptCategories } from "../../config/constants";
import { db } from "../../utils/firebase";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import imageCompression from "browser-image-compression";
import { useUser } from "../../context/UserContext";
import { GeneratingTokens, InfoRounded, Launch } from "@mui/icons-material";
import { formatFollowers } from "../../utils/Universalfunctions";
const animatedComponents = makeAnimated();


const PromptSubmit = () => {


     const { user, userData } = useUser();

     const [submitted, setSubmitted] = useState(false);
     const [uploading, setUploading] = useState(false);
     const [selectedFile, setSelectedFile] = useState(null);
     const [imageURL, setImageURL] = useState("");
     const [compressing, setCompressing] = useState(false);
     const [compressTime, setCompressTime] = useState(0);
     const [tags, setTags] = useState([]);
     const [visibility, setVisibility] = useState(
          userData?.subscriptions === "paid" ? "public" : "public"
     );


     const handleFileChange = async (file) => {
          if (!file) return;
          setCompressing(true);
          setCompressTime(0);

          const timer = setInterval(() => {
               setCompressTime(prev => prev + 1);
          }, 1000);

          const options = {
               maxSizeMB: 1,
               fileType: "image/png",
               useWebWorker: true,
          };

          try {

               const compressedFile = await imageCompression(file, options);

               const newFileName = `item.png`;

               const finalFile = new File([compressedFile], newFileName, {
                    type: compressedFile.type,
               });

               clearInterval(timer);
               setCompressing(false);
               setSelectedFile(finalFile);
          } catch (error) {
               clearInterval(timer);
               setCompressing(false);
               toasted.error("Compression failed!");
               console.error(error);
          }
     };


     const uploadToCloudinary = async (file) => {
          const UPLOAD_PRESET = "heyprompt_unsigned";

          const formData = new FormData();
          formData.append("file", file);
          formData.append("upload_preset", UPLOAD_PRESET);
          formData.append("folder", "heyprompt/prompts");

          try {
               setUploading(true);

               const res = await fetch(
                    `https://api.cloudinary.com/v1_1/dvlqi71yj/auto/upload`,
                    {
                         method: "POST",
                         body: formData,
                    }
               );

               const data = await res.json();
               setUploading(false);

               if (data.public_id) {
                    return data.public_id;
               } else {
                    toasted.error("❌ Image upload failed");
                    return null;
               }

          } catch (error) {
               setUploading(false);
               console.error(error);
               toasted.error("⚠ Upload error");
               return null;
          }
     };




     const handleSubmit = async (e) => {
          e.preventDefault();
          setSubmitted(true);


          if (!user) {
               alert("Login required");
               return;
          }

          const cost = visibility === "private" ? 12 : 5;

          if ((userData?.generation_credits || 0) < cost) {
               toasted.error(`Not enough credits. ${cost} credits required.`);
               setSubmitted(false);
               return;
          }



          if (!selectedFile) {
               setSubmitted(false);
               toasted.error("Please select an image!");
               return;
          }

          // Upload image
          const uploadedPublicId = await uploadToCloudinary(selectedFile);
          if (!uploadedPublicId) return;

          // Firestore Save
          try {
               await addDoc(collection(db, "prompts"), {
                    userId: userData?.uid,
                    username: userData?.name || userData?.username,
                    title: e.target.title.value,
                    promptText: e.target.prompt.value,
                    aiModel: e.target.ai_Name.value,
                    category: e.target.category.value,
                    promptSource: e.target.promptSource.value,
                    tags: tags,
                    imageUrl: uploadedPublicId,
                    layout: e.target.layout.value || "",
                    visibility: visibility,
                    status: "pending",
                    createdAt: serverTimestamp(),
                    likes: 0,
                    bookmarks: 0,
                    contentRating: "safe",
               });

               const userRef = doc(db, "users", userData?.uid);
               await updateDoc(userRef, {
                    prompt: increment(1),
                    generation_credits: increment(-cost)
               });


               toasted.success("Prompt submitted for review!");
               setSelectedFile(null);
               setImageURL("");
               setSubmitted(false);
               alert("Prompt submitted for review!");
               setTags([]);
               e.target.reset();

          } catch (err) {
               console.error(err);
               toasted.error("Something went wrong!");
               setSubmitted(false);
          }
     };



     const submitCost = visibility === "private" ? 12 : 5;
     const availableCredits = Number(userData?.generation_credits || 0);
     const canSubmit = availableCredits >= submitCost;


     const lastClaim = userData?.dailyClaimAt?.seconds || 0;
     const now = Date.now() / 1000;

     const canClaim = now - lastClaim >= 86400;

     return (
          <>

               <SEO
                    title="Submit AI Prompt (2026) – Share Your ChatGPT & Gemini Prompts | HeyPrompt"
                    description="Submit and publish your AI prompts on HeyPrompt. Share powerful prompts for ChatGPT, Gemini, Midjourney and other AI tools. Join the prompt creator community and showcase your best AI prompt ideas."
                    keywords="submit ai prompt, publish ai prompts, share chatgpt prompts, gemini prompt submission, ai prompt creators, prompt sharing platform, upload ai prompts, prompt engineering community"
                    canonicalPath={'/submit'}
               />


               <div className="__submit-sec">
                    <div className="__submit-contin">
                         <h1>Submit AI Prompt <br /> Share Your ChatGPT & Gemini Prompts.</h1>
                         <p className="sjk3">
                              Submit and publish your AI prompts on HeyPrompt. Share powerful prompts for ChatGPT, Gemini, Midjourney and other AI tools. Join the prompt creator community and showcase your best AI prompt ideas.
                         </p>



                         <div className="creator-overview-card mb-5">
                              <div className="creator-overview-content">
                                   <div className="creator-overview-copy">
                                        <span className="creator-overview-label">Creator stats</span>

                                        <p className="creator-overview-text mb-3">
                                             Creators like you make HeyPrompt better,
                                             <strong className="creator-accent"> {userData?.name}</strong> 🙌 -

                                             {userData?.prompt > 0 ? (
                                                  <>
                                                       you've already submitted{" "}
                                                       <Link to="/account" className="creator-inline-link">
                                                            {userData?.prompt} prompts <Launch />
                                                       </Link>{" "}
                                                       and you're currently on the{" "}
                                                       <strong className="creator-accent">{userData?.subscriptions} plan</strong>.
                                                       Keep going and earn money — every prompt inspires someone.
                                                  </>
                                             ) : (
                                                  <>
                                                       you are currently on the{" "}
                                                       <strong className="creator-accent">{userData?.subscriptions} plan</strong>.
                                                       Please start submitting prompts to earn money—every contribution inspires someone!
                                                  </>
                                             )}
                                        </p>




                                        {canClaim && (
                                             <p className="creator-overview-text mb-0 hdjkdf">
                                                  🎁 Daily Reward is ready! Claim your free credits now and use them
                                                  to submit more prompts on HeyPrompt. <Link to="/account">Claim now </Link>
                                             </p>
                                        )}

                                        {availableCredits < 5 && (
                                             <p className="credit-note">
                                                  Minimum 5 credits required for public submission
                                             </p>
                                        )}

                                   </div>

                                   <div className="creator-credit-pill">
                                        <span className="creator-credit-icon">
                                             <GeneratingTokens />
                                        </span>
                                        <div className="creator-credit-meta">
                                             <small>Available Credits</small>
                                             <strong>{formatFollowers(userData?.generation_credits || 0)}</strong>
                                        </div>
                                   </div>
                              </div>
                         </div>



                         {submitted && (
                              <div className="__sd__jdkwl3md" role="alert">
                                   <div className="__kjl-3kdh4">
                                        <div className="loader"></div>
                                        Thank you for your submission! Your prompt has been received and is under review. We appreciate your contribution to our community.
                                   </div>
                              </div>
                         )}



                         <form onSubmit={handleSubmit} method="POST">

                              {canSubmit ?
                                   <div className="row">
                                        <div className="col-12">
                                             <div className="input-sec">
                                                  <label className="form-label">tags</label>
                                                  <Select
                                                       required
                                                       closeMenuOnSelect={false}
                                                       components={animatedComponents}
                                                       defaultValue={[categoriesItes[0]]}
                                                       isMulti
                                                       options={categoriesItes}
                                                       onChange={(selected) => setTags(selected.map(item => item.value))}
                                                       placeholder="Select tags for your prompt"
                                                  />

                                             </div>
                                        </div>

                                        <div className="col-md-6">
                                             <div className="input-sec">
                                                  <label className="form-label">title *</label>
                                                  <input
                                                       type="text"
                                                       name="title"
                                                       className="form-control"
                                                       placeholder="Enter your prompt title"
                                                       required
                                                  />
                                             </div>
                                        </div>

                                        <div className="col-md-6">
                                             <div className="input-sec">
                                                  <label className="form-label">category</label>
                                                  <select className="form-select" name="category" id="category" required placeholder="Select category for your prompt" >
                                                       <option value=""> Select Layout </option>
                                                       {promptCategories.map((category) => (
                                                            <option key={category.value} value={category.value}>
                                                                 {category.label}
                                                            </option>
                                                       ))}
                                                  </select>
                                             </div>
                                        </div>

                                        <div className="col-md-6">
                                             <div className="input-sec">
                                                  <label className="form-label">Layout</label>
                                                  <select className="form-select" name="layout" placeholder="Select Layout">
                                                       <option value=""> Select Layout </option>
                                                       <option value="square">Square</option>
                                                       <option value="landscape">Landscape</option>
                                                       <option value="portrait">Portrait</option>
                                                  </select>
                                             </div>
                                        </div>

                                        <div className="col-md-6">
                                             <div className="input-sec">
                                                  <label className="form-label">AI model name</label>
                                                  <select className="form-select" name="ai_Name" required id="ai_Name" placeholder="Enter the AI model name (e.g., DALL·E 2, Midjourney">
                                                       <option value=""> Choose AI model name </option>
                                                       <option value="chatGPT">ChatGPT</option>
                                                       <option value="midjourney">Midjourney</option>
                                                       <option value="flux">FLUX</option>
                                                       <option value="claude">Claude</option>
                                                       <option value="gemini">Gemini</option>
                                                       <option value="llama">Llama</option>
                                                  </select>
                                             </div>
                                        </div>

                                        <div className="col-md-6">
                                             <div className="input-sec">
                                                  <label className="form-label">Criteria
                                                       <Link to="/marketplace" className="ms-1"><InfoRounded fontSize="10" /> </Link>
                                                  </label>
                                                  <select className="form-select" name="visibility" required id="visibility" placeholder="Enter Criteria Like Public, Private"
                                                       value={visibility}
                                                       onChange={(e) => setVisibility(e.target.value)}>
                                                       <option value="public">Public ( 5 Credits )</option>
                                                       <option
                                                            value="private"
                                                            disabled={userData?.planDetails?.planTitle === "7 Days"}
                                                       >
                                                            Exclusive ( 12 Credits )
                                                       </option>

                                                  </select>

                                                  <p className="mb-1 mt-1 text-danger" style={{ fontSize: '14px' }}> {userData?.planDetails?.planTitle === "7 Days" && 'you are not eligible for exclusive prompt submited'}</p>
                                             </div>
                                        </div>

                                        <div className="col-md-6">
                                             <div className="input-sec">
                                                  <label className="form-label">Prompt Source</label>
                                                  <select className="form-select" name="promptSource" required id="promptSource" placeholder="Select the source of your prompt">
                                                       <option value="">Select Source</option>
                                                       <option value="original">Original Creation</option>
                                                       <option value="inspired">Inspired (Reworked)</option>
                                                       <option value="copied">Copied (As is)</option>
                                                  </select>
                                             </div>
                                        </div>

                                        <div className="col-12">
                                             <div className="input-sec">
                                                  <label className="form-label">Prompt *</label>
                                                  <textarea
                                                       name="prompt"
                                                       className="form-control"
                                                       rows="7"
                                                       placeholder="Please enter the prompt used to generate this image & any special instructions."
                                                       required
                                                  ></textarea>
                                             </div>
                                        </div>


                                        <div className="col-12">
                                             <div className="upload-container">
                                                  <label className="form-label">Upload Image *</label>



                                                  <div
                                                       className={`upload-box ${uploading ? "uploading" : ""} ${imageURL || selectedFile ? "uploaded" : ""}`}
                                                       onDragOver={(e) => e.preventDefault()}
                                                       onDrop={(e) => {
                                                            e.preventDefault();
                                                            if (imageURL || selectedFile) return;
                                                            const file = e.dataTransfer.files[0];
                                                            if (file) handleFileChange(file);
                                                       }}
                                                       onClick={() => {
                                                            if (imageURL || selectedFile) return;
                                                            document.getElementById("fileInput").click();
                                                       }}
                                                  >
                                                       {!selectedFile && !imageURL && (
                                                            <>
                                                                 {compressing ?
                                                                      <div className="compress-box">
                                                                           <p>⏳ Compressing image… please wait</p>
                                                                           <small>{compressTime}s elapsed</small>
                                                                      </div>
                                                                      :
                                                                      <div className="upload-instructions">
                                                                           <p className="upload-text">📂 Drag & Drop your image here</p>
                                                                           <span className="upload-hint">or click to select</span>
                                                                      </div>

                                                                 }

                                                            </>
                                                       )}

                                                       {selectedFile && !imageURL && (
                                                            <div className="preview">
                                                                 <img src={URL.createObjectURL(selectedFile)} alt="Preview" />
                                                                 <p className="text-info">Ready to upload</p>
                                                                 <button
                                                                      type="button"
                                                                      className="remove-btn"
                                                                      onClick={() => setSelectedFile(null)}
                                                                 >
                                                                      Remove
                                                                 </button>
                                                            </div>
                                                       )}

                                                       {uploading && <p className="uploading-text">⏳ Uploading...</p>}

                                                       {imageURL && (
                                                            <div className="preview">
                                                                 <img src={imageURL} alt="Uploaded" />
                                                                 <p className="success-text">✅ Uploaded Successfully</p>
                                                            </div>
                                                       )}
                                                  </div>

                                                  <input
                                                       type="file"
                                                       id="fileInput"
                                                       name="imageFile"
                                                       accept=".jpg, .jpeg, .png, .gif, .webp, .avif"
                                                       style={{ display: "none" }}
                                                       onChange={(e) => handleFileChange(e.target.files[0])}
                                                  />

                                                  <input type="hidden" name="image_url" value={imageURL} readOnly />

                                                  <div className="upload-conditions mt-2">
                                                       <p>Image Guidelines:</p>
                                                       <ul>
                                                            <li>Accepted formats: JPEG, PNG, GIF</li>
                                                            <li>Maximum file size: 5 MB</li>
                                                            <li>Recommended dimensions: 1080px × 1080px (for square layout)</li>
                                                            <li>Only one image can be uploaded at a time</li>
                                                            <li>Click or drag & drop to select an image</li>
                                                       </ul>
                                                  </div>
                                             </div>
                                        </div>

                                        <div className="col-12">
                                             <button
                                                  type="submit"
                                                  className="submit-prompt-btn"
                                                  disabled={uploading || submitted}
                                             >
                                                  {uploading || submitted
                                                       ? "Please wait..."
                                                       : <>
                                                            Submit Prompt
                                                            <span className="submit-cost">
                                                                 <GeneratingTokens />
                                                                 {submitCost} Credits
                                                            </span>
                                                       </>
                                                  }
                                             </button>
                                        </div>

                                        <div className="col-12 mt-4">
                                             <div className="submit-review-note">
                                                  <div className="submit-review-note-icon">
                                                       <InfoRounded />
                                                  </div>

                                                  <div className="submit-review-note-content">
                                                       <h6>Review Process</h6>
                                                       <p className="mb-0">
                                                            All submissions are reviewed by our team to maintain quality and relevance.
                                                            Once approved, your prompt will be published on the gallery. Most reviews are
                                                            completed within 10–20 minutes.
                                                       </p>
                                                  </div>
                                             </div>
                                        </div>

                                   </div>
                                   :
                                   <div className="row">
                                        <div className="col-12">
                                             <div className="credit-action-card">
                                                  <div className="credit-action-copy">
                                                       <div className="credit-action-icon">
                                                            <GeneratingTokens />
                                                       </div>

                                                       <div className="credit-action-text">
                                                            <h6>Not enough credits</h6>
                                                            <p>
                                                                 You need <strong>{submitCost}</strong> credits to submit this prompt.
                                                                 Available credits: <strong>{availableCredits}</strong>
                                                            </p>
                                                       </div>
                                                  </div>

                                                  <div className="credit-action-buttons">
                                                       <Link to="/pricing" className="get-credits-btn">
                                                            Get Credits
                                                       </Link>

                                                       {availableCredits >= 5 &&
                                                            <button
                                                                 type="button"
                                                                 className="switch-public-btn"
                                                                 onClick={() => setVisibility("public")}
                                                            >
                                                                 Submit Only Public Prompt
                                                            </button>}



                                                  </div>
                                             </div>
                                        </div>
                                   </div>


                              }

                         </form>
                    </div>
               </div>

          </>

     );
};

export default PromptSubmit;
